export const gql = (literals: TemplateStringsArray, ...placeholders: string[]) => {
  return literals
    .map((value, index) => `${value}${placeholders.length > index ? placeholders[index] : ''}`)
    .join('');
};
